<template lang="pug">
  .main
    .fields
      .item(v-for="field in fields" :class="className")
        label {{field.label}}
        .field_container(v-if="field.type === 'WebiomedInput'")
          WebiomedInput(v-model="filter[field.search_by]" :value="filter[field.search_by]")
        .field_container(v-if="field.type === 'WebiomedSelect'")
          WebiomedSelect(:options="field.params.options" v-model="filter[field.search_by]" :value="filter[field.search_by]")

    .buttons(v-if="fields.length")
      button.find(@click="find") Найти
      button.clear(@click="clear") Очистить фильтры
      div(style="display: inline-block; margin-left: 5px") Количество записей:
      span(style="font-weight: bold") {{' ' +count}}
</template>
<script>
import WebiomedInput from '@/components/fields/WebiomedInput'
import WebiomedSelect from '@/components/fields/WebiomedSelect'

export default {
  components: {
    WebiomedSelect,
    WebiomedInput
  },
  props: ['fields', 'count', 'className'],
  data () {
    return {
      filter: {}
    }
  },
  methods: {
    find () {
      this.$parent.findKey = true
      if (!this.$refs.grid) {
        this.$refs.grid = {
          spinnerON: true
        }
      } else {
        this.$refs.grid.spinnerON = true
      }
      this.$parent.getData(this.filter)
    },
    clear () {
      this.$parent.findKey = true
      if (!this.$refs.grid) {
        this.$refs.grid = {
          spinnerON: true
        }
      } else {
        this.$refs.grid.spinnerON = true
      }
      this.filter = {}
      this.$parent.clear()
    }
  }
}
</script>
<style lang="sass" scoped>
.fields
  padding-left: 40px
  padding-right: 40px
  display: grid
  grid-template-columns: 1fr 1fr 1fr
  grid-column-gap: 40px
.field_container
  margin-top: 7px
.item
  margin-bottom: 20px
.full_length
  grid-column: 1 / span 3
.buttons
  margin: 20px 40px 30px 40px
.buttons button
  font-family: 'Roboto'
  height: 35px
  min-width: 100px
  margin-right: 8px
  font-size: 15px
  border-radius: 4px
  cursor: pointer
.find
  background: #035cc9
  color: white
  border: none
.find:hover
  transition: all, 0.3s
  background: #024597
  color: white
  border: none
.clear
  padding: 0 10px
  transition: all, 0.3s
  background: none
  border: 1px solid #ccc
.clear:hover
  background: #e6e6e6
</style>
